import '../styles/globals.css'; // Import global styles
import Navigation from "../components/Navigation"; // Import the Navigation component
import Footer from '../components/Footer';
import { useRouter } from 'next/router'; // Import useRouter from Next.js
import { Analytics } from '@vercel/analytics/react';
import { SpeedInsights } from '@vercel/speed-insights/next';
import Script from 'next/script'; // Import Script from Next.js
import { UserProvider } from '../components/Navigation'; // Import named export
import { ThemeProvider } from 'next-themes';
import Head from 'next/head';

function MyApp({ Component, pageProps }) {
  const router = useRouter(); // Get the router instance

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://doogler.in"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Job Search",
        "item": "https://doogler.in/job_search"
      },
      {
        "@type": "ListItem",
        "position": 3,
        "name": "Browse Jobs",
        "item": "https://doogler.in/browse-jobs"
      }
    ]
  };

  // Define the routes where the Navigation should not be shown
  const noNavigationRoutes = ['/admin-login', '/admin-dashboard'];

  return (
    <UserProvider>
      <ThemeProvider attribute="class" defaultTheme="system" enableSystem>
        <Head>
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }}
          />
        </Head>
        {/* Google Tag Manager Script */}
        <Script
          strategy="afterInteractive"
          src="https://www.googletagmanager.com/gtag/js?id=G-1XMB1M6104"
        />
        <Script
          id="gtag-init"
          strategy="afterInteractive"
        >
          {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'G-1XMB1M6104');
          `}
        </Script>
        <link
          rel="stylesheet"
          href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css"
        />
        {/* Conditionally render the Navigation based on the current route */}
        {!noNavigationRoutes.includes(router.pathname) && <Navigation />}
        <Component {...pageProps} /> {/* This renders the specific page component */}
        {!noNavigationRoutes.includes(router.pathname) && <Footer />}
        <Analytics />
        <SpeedInsights />
      </ThemeProvider>
    </UserProvider>
  );
}

export default MyApp;
